import ROLES from '@/constants/ROLES'

export default [
  {
    path: '/',
    name: 'Home',
    redirect: '/login',
    component: () => import(/* webpackChunkName: "home" */ '../pages/login/Index.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../pages/login/Index.vue'),
    meta: {
      layout: 'Empty',
      roles: [ROLES.EVERYONE],
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ '../pages/settings/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../pages/dashboard/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },

  // CLIENTS
  {
    path: '/clients',
    name: 'Clients',
    component: () => import(/* webpackChunkName: "clients" */ '../pages/clients/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/clients/add',
    name: 'Add Client',
    component: () => import(/* webpackChunkName: "clients-add" */ '../pages/clients/Add.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/clients/:id',
    name: 'View Client',
    props: true,
    component: () => import(/* webpackChunkName: "clients-view" */ '../pages/clients/View.vue'),
    meta: {
      hideClientSearch: true,
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/clients/:id/edit',
    name: 'Edit Client',
    props: true,
    component: () => import(/* webpackChunkName: "clients-edit" */ '../pages/clients/Edit.vue'),
    meta: {
      hideClientSearch: true,
      roles: [ROLES.CONNECTED],
    },
  },

  // PRODUCTS
  {
    path: '/products',
    name: 'Products',
    component: () => import(/* webpackChunkName: "products" */ '../pages/products/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/products/add',
    name: 'Add Product',
    component: () => import(/* webpackChunkName: "products-add" */ '../pages/products/Add.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/products/:id',
    name: 'View Product',
    props: true,
    component: () => import(/* webpackChunkName: "products-view" */ '../pages/products/View.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/products/:id/edit',
    name: 'Edit Product',
    props: true,
    component: () => import(/* webpackChunkName: "products-edit" */ '../pages/products/Edit.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },

  // QUOTES
  {
    path: '/quotes',
    name: 'Quotes',
    component: () => import(/* webpackChunkName: "quotes" */ '../pages/quotes/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/quotes/add',
    name: 'Add Quote',
    component: () => import(/* webpackChunkName: "quotes-add" */ '../pages/quotes/Add.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/quotes/:doc_number',
    name: 'View Quote',
    props: true,
    component: () => import(/* webpackChunkName: "quotes-view" */ '../pages/quotes/View.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
      layout: 'Document',
      enableOffline: true,
    },
  },
  {
    path: '/quotes/:doc_number/edit',
    name: 'Edit Quote',
    props: true,
    component: () => import(/* webpackChunkName: "quotes-edit" */ '../pages/quotes/Edit.vue'),
    meta: {
      hideClientSearch: true,
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/quotes/:doc_number/upload',
    name: 'Upload for Quote',
    props: true,
    component: () => import(/* webpackChunkName: "quotes-upload" */ '../pages/quotes/Upload.vue'),
    meta: {
      hideClientSearch: true,
      roles: [ROLES.CONNECTED],
    },
  },

  // INVOICES
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import(/* webpackChunkName: "invoices" */ '../pages/invoices/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/invoices/add',
    name: 'Add Invoice',
    component: () => import(/* webpackChunkName: "invoices-add" */ '../pages/invoices/Add.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/invoices/:doc_number',
    name: 'View Invoice',
    props: true,
    component: () => import(/* webpackChunkName: "invoices-view" */ '../pages/invoices/View.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
      layout: 'Document',
      enableOffline: true,
    },
  },
  {
    path: '/invoices/:doc_number/edit',
    name: 'Edit Invoice',
    props: true,
    component: () => import(/* webpackChunkName: "invoices-edit" */ '../pages/invoices/Edit.vue'),
    meta: {
      hideClientSearch: true,
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/invoices/:doc_number/upload',
    name: 'Upload Invoice',
    props: true,
    component: () => import(/* webpackChunkName: "invoices-upload" */ '../pages/invoices/Upload.vue'),
    meta: {
      hideClientSearch: true,
      roles: [ROLES.CONNECTED],
    },
  },

  // Acomptes
  {
    path: '/acomptes/quote/:doc_number',
    name: 'Acompte Quote',
    props: true,
    component: () => import(/* webpackChunkName: "invoices-upload" */ '../pages/acomptes/quote/_doc_number.vue'),
    meta: {
      hideClientSearch: true,
      roles: [ROLES.CONNECTED],
    },
  },

  // CREDIT NOTES
  {
    path: '/credit-notes',
    name: 'Credit Notes',
    component: () => import(/* webpackChunkName: "credit-notes" */ '../pages/credit-notes/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/credit-notes/add',
    name: 'Add Credit Note',
    component: () => import(/* webpackChunkName: "credit-notes-add" */ '../pages/credit-notes/Add.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/credit-notes/:doc_number',
    name: 'View Credit Note',
    props: true,
    component: () => import(/* webpackChunkName: "credit-notes-view" */ '../pages/credit-notes/View.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
      layout: 'Document',
      enableOffline: true,
    },
  },

  // PRODUCTION
  {
    path: '/production',
    name: 'Production',
    component: () => import(/* webpackChunkName: "production" */ '../pages/production/Index.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
    },
  },
  {
    path: '/production/:id',
    name: 'View Production',
    component: () => import(/* webpackChunkName: "production-view" */ '../pages/production/View.vue'),
    meta: {
      roles: [ROLES.CONNECTED],
      layout: 'Document',
      enableOffline: true,
    },
  },
]
